import { OrderStatus } from '@dss-libs/shared/type/common-types';

const badgeClassMap = new Map<OrderStatus, string>([
  [OrderStatus.Completed, 'success'],
  [OrderStatus.Cancelled, 'danger'],
  [OrderStatus.Declined, 'danger'],
  [OrderStatus.Expired, 'danger'],
]);

export function getOrderStatusBadgeClass(status: OrderStatus): string {
  return badgeClassMap.get(status) ?? 'warning';
}
